var cov_18un2k4tcj = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Upload/styles/index.ts",
      hash = "9a4ccfa6a21ac87c8f2d40cbd218ddde8244939f",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Upload/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 27
        },
        end: {
          line: 5,
          column: 59
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var uploadLess = {};
import genaration from '../../utils/classname';
export var uploadClass = (cov_18un2k4tcj.s[0]++, genaration(uploadLess, 'upload'));